import { FC } from 'react'
import FormItem from 'antd/es/form/FormItem'
import { RequestCreateLeadPaymentLink } from '@/api/types/crm/crm.types'
import CreateLinkNumberInput, {
  createLinkNumberRuleTransform,
} from '../../CreateLinkNumberInput'
import spclasses from '../../../SetCourseClassDirectionModal/purchase.module.css'
import sclasses from '../../../SetCourseClassDirectionModal/index.module.css'

type FieldType = Omit<RequestCreateLeadPaymentLink, 'lead_funnel_id'>

/**
 * UI CRM-ссылки для stream_one_time: только инпут итоговой цены.
 */
const StreamOneTimeLinkFields: FC = () => {
  return (
    <div className={sclasses.inputWithLabel}>
      <FormItem<FieldType>
        name="price"
        rules={[
          {
            required: true,
            message: 'Укажите стоимость покупки',
          },
          {
            type: 'number',
            min: 0,
            message: 'Цена не может быть отрицательной',
            transform: createLinkNumberRuleTransform,
          },
        ]}
        noStyle
      >
        <CreateLinkNumberInput
          className={spclasses.input}
          title="Стоимость покупки (в руб.)"
          min={0}
          placeholder={0}
        />
      </FormItem>
    </div>
  )
}

export default StreamOneTimeLinkFields
